<template>
  <v-row class="ml-0" dense>
    <!-- 说明 -->
    <v-col cols="12" class="pt-0 pl-0">
      <v-card tile>
        <v-card-title>
          <v-icon color="teal" class="mr-2">mdi-arrow-right-circle-outline</v-icon>{{moduleDetailData.module.name}}
        </v-card-title>
        <v-card-text>
          <div v-html="moduleDetailData.module.note" style="text-indent:2em;"></div>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- 参数配置 -->
    <v-col cols="12" class="pl-0" v-if="taskList.length && runEnabled">
      <!-- 固定参数: 样品设置方案, 比较组 -->
      <v-card tile>
        <v-card-title>
          <v-icon color="teal" class="mr-2">mdi-arrow-right-circle-outline</v-icon>参数设置
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="3">
              <v-select :items="vsList" v-model="selectedVS" label="请选择比较组" outlined dense hide-details></v-select>
            </v-col>
            <v-col cols="12"></v-col>
            <v-col cols="12" v-if="params.length">
              <!-- 动态参数 -->
              <analyse-param-form :items="params" :coder="coder"></analyse-param-form>
            </v-col>
            <v-col cols="3">
              <v-text-field label="请输入任务标记(选填)" v-model="mark" hide-details dense outlined></v-text-field>
            </v-col>
            <v-col cols="5">
              <v-btn color="primary" :disabled="shareData && !shareData.analyseExec" v-one-click @click="onExecute">运 行</v-btn>
              <span v-if="shareData && !shareData.analyseExec" style="color: #FF0000; font-size: 12px;line-height: 36px; margin-left: 10px">*您没有当前项目的流程分析权限，请联系项目分享人</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- 分析工具 -->
    <v-col cols="12" class="pl-0">
      <v-card tile>
        <v-card-title>
          <v-icon color="teal" class="mr-2">mdi-arrow-right-circle-outline</v-icon>分析结果
          <v-select v-if="taskList.length" :items="taskList" v-model="selectedTask" @change="onTaskChanged" item-text="name" item-value="name" class="ml-2" style="max-width:280px;" label="请选择分析结果" outlined dense hide-details></v-select>
        </v-card-title>
        <v-card-text>
          <v-tabs v-if="tools.length" v-model="tabIndex">
            <v-tab v-for="(tool,index) in tools" :key="index">{{tool.title}}</v-tab>
            <v-tab-item v-for="(chart,i) in charts" :key="i">
              <v-row>
                <v-col cols="12" class="d-flex">
                  <v-select v-if="chart.vsFlag" :items="taskVSList" @change="onTaskVSChanged(i)" item-text="name" item-value="name" v-model="toolSelectedVS[i]" style="max-width:280px;" label="选择比较组" outlined dense hide-details></v-select>
                  <v-btn v-if="tools[i].saveFlag" color="deep-orange" text @click="onSaveToReport(i)" class="ml-2 mt-1" v-one-click>存入报告</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="(tools[i].toolResultType == 'Html' || tools[i].toolResultType == 'Table' || tools[i].toolResultType == 'Image') ? 12 : tools[i].toolResultType == 'Bar_GO' ? 7 : 'auto'">
                  <component :ref="`chart_${i}`" :is="chart.cpt" v-bind="chart.props" style="table-layout:fixed;min-width:500px;"></component>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  {{tools[i].note}}
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import AnalyseParamForm from '../AnalyseParamForm.vue';
import { userFileRead, userFileList, userFileWrite, reportTaskCheck, runReportTask } from '@/plugins/api';
import { getImgData, getPdfData } from '@/plugins/chart';
import { EXP_ANALYSE_CONTENT } from '@/plugins/rules';


export default {
  components: { AnalyseParamForm },
  props: [
    'reportData', 'moduleDetailData',
    'reportId', 'moduleId', 'type', 'xmh', 'schema', 'projectInfo', "shareData"
  ],
  data () {
    return {
      tabIndex: 0, tabIndexWatchEnabled: true,
      vsList: [], selectedVS: '',
      basicTask: null, mark: null,
      taskList: [], selectedTask: '',
      taskVSList: [], toolSelectedVS: {},
      charts: [],


    }
  },
  computed: {
    runEnabled () { return this.moduleDetailData.module.runEnabled },
    coder () { return this.moduleDetailData.coder },
    params () { return this.moduleDetailData.params },
    tools () { return this.moduleDetailData.tools },
    vp () { return { type: this.type, xmh: this.xmh, schema: this.schema, task: this.selectedTask.substring(this.selectedTask.lastIndexOf('/') + 1) } }
  },
  created () { this.init() },
  watch: {
    moduleId () {
      this.tabIndex = 0;
      this.tabIndexWatchEnabled = false;
      this.vsList = [];
      this.selectedVS = '';
      this.taskList = [];
      this.selectedTask = '';
      this.taskVSList = [];
      this.toolSelectedVS = {};
      this.charts = [];
      this.init();
      this.$nextTick(() => this.tabIndexWatchEnabled = true)
    },
    tabIndex (v) {
      if (this.tabIndexWatchEnabled) {
        this.initTool(v);
      }
    }
  },
  methods: {
    async init () {
      // 初始化样品方案的比较组列表
      await userFileRead({ path: `/${this.type}/${this.xmh}/Result/${this.schema}/Design/GroupVS.xlsx` }).then(res => {
        let d = res.data;
        this.vsList.push({ value: '', text: 'All' });
        d.slice(1).forEach(row => this.vsList.push({ value: row[0], text: row[0] }));
      });
      // 初始化历史分析任务列表
      let path = this.moduleDetailData.module.path;
      if (path) {
        path = this.Utility.fmtExpress(path, this.vp);
        let parent = path.substring(0, path.lastIndexOf('/')), dir = path.substring(path.lastIndexOf('/') + 1);
        this.basicTask = dir;
        await userFileList({ path: parent, regex: `${this.basicTask}.*`, sort: 'desc' }).then(res => this.taskList = res.data || []);
        this.selectedTask = this.taskList[0].name;
        // 根据当前的任务获取比较组列表
        await this.initTaskVSList();
      }
      // 初始化分析工具
      if (this.tools.length) {
        for (let i = 0; i < this.tools.length; i++) this.charts[i] = {};
        await this.initTool(0);
      }
    },
    async initTaskVSList () {
      await userFileList({ path: `/${this.type}/${this.xmh}/Result/${this.schema}/${this.selectedTask}`, regex: '(.+_vs_.+)|(.+_oneway)', sort: 'desc' }).then(res => this.taskVSList = res.data || []);
    },
    async initTool (index) {
      let vs;
      if (this.taskVSList.length) {
        if (!this.toolSelectedVS[index]) this.toolSelectedVS[index] = this.taskVSList[0].name;
        vs = this.toolSelectedVS[index];
      }
      let tool = this.tools[index], path = this.Utility.fmtExpress(tool.dataSource, { vs: vs, ...this.vp });
      let ct = this.charts[index];
      if (!ct || !ct.props) {
        let toolResultType = tool.toolResultType;
        ct = {
          vsFlag: !!vs,
          props: {
            chartContainerId: `module_tool_${index}`,
            embed: true, dataSourceParam: { path: path },
            tool: {
              type: toolResultType,
              params: tool.toolResultParams,
              coder: this.moduleDetailData.coder
            }
          }
        }
        if (tool.optionBuildConfig) ct.props.config = JSON.parse(this.Utility.fmtExpress(tool.optionBuildConfig, { vs: vs, ...this.vp }));
        await import(`@/views/Component/ChartLib/${toolResultType}`).then(res => ct.cpt = res.default);
      } else {
        ct.props.dataSourceParam.path = path;
      }
      let paramConfig = tool.paramConfig ? JSON.parse(tool.paramConfig) : {};
      let { width, extWidth } = { ...paramConfig }
      ct.props.width = width || '400px'
      ct.props.extWidth = extWidth || '400px'
      delete paramConfig.width
      delete paramConfig.extWidth
      // 加载存入报告的图表参数
      if (tool.saveFlag) {
        let cpv = {};
        let saveFileParam = this.Utility.fmtExpress(tool.saveFileParam, { vs: vs, ...this.vp });
        let exists;
        await userFileRead({ path: saveFileParam, stream: false }).then(res => exists = res.data);
        if (exists) {
          await userFileRead({ path: saveFileParam }).then(res => cpv = JSON.parse(res.data));
        }
        this.Utility.deepMerge(paramConfig, cpv);
      }
      ct.props.paramValue = paramConfig;
      this.$set(this.charts, index, ct);
    },

    // 切换分析任务
    async onTaskChanged () {
      this.charts = [];
      this.toolSelectedVS = [];
      await this.initTaskVSList();
      if (this.tools.length) {
        for (let i = 0; i < this.tools.length; i++) this.charts[i] = {};
        await this.initTool(0);
        this.$refs[`chart_0`][0].init();
      }
    },

    // 切换分析任务下的比较组
    async onTaskVSChanged (index) {
      this.$set(this.charts, index, {});
      await this.initTool(index);
    },


    async onExecute () {
      if (this.mark) {
        if (this.mark.length > 20) {
          this.$message.error('请输入20个字符以内的任务标记');
          return;
        }
        if (!EXP_ANALYSE_CONTENT.test(this.mark)) {
          this.$message.error('任务标记格式输入错误,不允许包含[\\/:：?*#!%$@]');
          return;
        }
      }
      let taskParam = this.getTaskParam();
      let valid = await this.validateTaskParam(taskParam);
      if (valid === false) return;
      let newTask = taskParam.basicParam.task + '_' + (taskParam.mark || this.Utility.now());
      taskParam.basicParam.task = newTask;
      this.runTask(taskParam);
    },
    runTask (taskParam) {
      runReportTask(taskParam).then(() => {
        this.$message.success('已成功提交任务,请关注分析结果');
      })
    },
    // 获取任务summary
    getTaskParam () {
      return {
        mark: this.mark,
        basicParam: { reportId: this.reportId, moduleId: this.moduleId, type: this.type, xmh: this.xmh, schema: this.schema, task: this.basicTask, vs: this.selectedVS, oaProjectInfo: JSON.stringify(this.projectInfo) },
        items: this.params.length ? this.$refs.paramForm.getBillData() : []
      }
    },
    // 任务校验
    async validateTaskParam (taskParam) {
      let sameTask;
      await reportTaskCheck(taskParam).then(res => sameTask = res.data);
      if (sameTask) {
        this.$message.error(`已存在相同参数的任务结果:[${sameTask.mark}]`);
        return false;
      }
    },


    // 存入报告
    async onSaveToReport (index) {
      this.$store.commit('showLoading');
      let chartCpt = this.$refs[`chart_${index}`][0];
      if (chartCpt.noData) {
        this.$message.error('暂无数据');
        return;
      }
      let tool = this.tools[index];
      // 暂停1秒后再去获取图表组件的svg
      await new Promise(resolve => { setTimeout(() => { resolve() }, 1000) })
      let vs = this.toolSelectedVS[index];
      let cpv = chartCpt.paramFormData;
      let saveFileParam = this.Utility.fmtExpress(tool.saveFileParam, { ...this.vp, vs: vs });
      // 获取imgData,存储为图片
      let svgNode = chartCpt.getSvg();
      let sw = svgNode.width.baseVal.value, sh = svgNode.height.baseVal.value, dpi = 150, scale = dpi / 72;
      let w = parseInt(sw * scale), h = parseInt(sh * scale);
      let imgData = await getImgData(svgNode, w, h);
      let saveFilePng = this.Utility.fmtExpress(tool.saveFilePng, { ...this.vp, vs: vs });
      let pdfData = await getPdfData(svgNode, w, h, dpi);
      let saveFilePdf = saveFilePng.substring(0, saveFilePng.lastIndexOf('.')) + '.pdf';

      let formData = new FormData();
      formData.append(saveFileParam, JSON.stringify(cpv)); // 存储图表参数
      formData.append(saveFilePng, imgData); // 存储图片
      formData.append(saveFilePdf, pdfData); // 存储pdf
      await userFileWrite(formData).then(() => {
        this.$store.commit('hideLoading');
        this.$message.success('操作成功');
      });
    }
  }
}
</script>